import { VerifyEmailForm } from '@/features/identity/components/VerifyEmailForm';

export function VerifyEmailPage() {
  return <VerifyEmailForm />;
}
